import React from "react";
import PropTypes from "prop-types";
import Media from "../../Generic/Carousel/CarouselMedia";
import Image from "next/image";
import LazyLoad from 'react-lazy-load';
import Typography from "../../Generic/Typography/Typography";

const IconBanner = ({ bannerImage,imageListCollection,title, footerText,isNoWidth }) => {
    if (!bannerImage?.desktopImage?.url && !bannerImage?.smartphoneImage?.url && !bannerImage?.tabletImage?.url) {
        return null;
    }

    return (
        <div className="smallBannerContainer mb-10 relative overflow-hidden lg:px-0 pt-0 xl:pt-0">
            <div className="relative clear-both lg:pt-0 iconBanner">
                <div className="mx-auto main-heading w-70p md:w-70p md:max-w-70p absolute left-0 right-0 top-20 lg:top-50 xl:top-60">
                    <h2 className="uppercase text-25 md:text-39 xl:text-39 color-gradient-yellow-stack font-BebasNeueBold text-center tracking-1.74 md:tracking-4 iconSectionTitle">
                        {title}
                    </h2>
                </div>
                <Media
                    isNoWidth={isNoWidth}
                    isLazyLoad
                    component="bannerPicture"
                    srcset={bannerImage?.desktopImage?.url}
                    image={bannerImage?.smartphoneImage?.url}
                    altText={bannerImage?.altText}
                    priority={true}
                    className="w-full object-cover md:object-fill xl:object-cover object-center xl:h-auto IconImage"
                />
                <div className="iconList absolute top-[50%] md:top-[27%] xl:top-[25%] md:px-0 px-25 left-0 md:left-35p overflow-hidden w-full right-0 mt-20 text-white md:w-60p">
                    {/* Grid in 3 cols */}
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                        {imageListCollection.items.map((item, index) => (
                            <div className="flex flex-nowrap items-center mb-10 xl:mb-25 gap-5 col-span-1" key={index}>
                                <LazyLoad offset={-50} height={96} className="icon w-50 md:w-57 xl:w-57 xl:h-57 h-50 md:h-57 iconImages">
                                    <Image
                                        src={item.iconImageSet?.desktopImage?.url}
                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        alt={`Icono ${item.title}`}
                                        className="w-full h-auto object-cover object-center"
                                        loading="lazy"
                                        width={60}
                                        height={60}
                                    />
                                </LazyLoad>
                                <div className="w-1/2 md:w-60p md:ml-10">
                                    <Typography className="text-black text-8 md:text-12 xl:text-16 text-wrap font-HelveticaNeueMedium md:tracking-1.74 uppercase iconText">
                                        {item.title}
                                    </Typography>
                                </div>
                            </div>
                        ))}
                        <div className="col-span-2 px-40 md:px-15 md:col-span-3 mt-10 md:mt-25 iconBottomheading">
                            <Typography dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(footerText)
                            }} component="h3" className="text-black tracking-wider2x md:tracking-wider3x text-center font-normal color-gradient-yellow-stack text-20 md:text-28 xl:text-35" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const IconBanner = ({ prop = val }) =>

IconBanner.propTypes = {
    bgImage: PropTypes.object,
    bannerImage: PropTypes.object.isRequired,
    imagelistCollection: PropTypes.object,
    title: PropTypes.string,
    footerText: PropTypes.string,
};
export default IconBanner;